import React from "react"
import Slider from "react-slick"
import { colorCode } from "../../functions/middle-category-style"
import LazyAndPreloadImage from "../../functions/lazy_and_preload_image"
import { Link } from "gatsby"

export default function MagazineSlider({ data }) {
  const settings = {
    infinite: true,
    centerMode: true,
    adaptiveHeight: true,
    swipe: true,
    touchMove: true,
    autoplay: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    variableWidth: true,
  }
  return (
    <Slider {...settings}>
      {data.magazineForSlide.edges.map(({ node }) => (
        <div key={node.notesId}>
          <Link to={'/note/' + node.notesId}>
            <div className="slide_box">
              { node.middle_category ?
              <span className="category_ico" style={{background: colorCode(node.middle_category.display_color ? node.middle_category.display_color[0] : '')}}>{node.middle_category.name}</span>
              : ''
              }
              <div className="article_ttl"><span>{node.title}</span></div>
            </div>
            <LazyAndPreloadImage imgUrl={node.thumbnail ? node.thumbnail.url : ''} alt={node.title} />
          </Link>
        </div>
      ))}
    </Slider>
  )
}
